import React from 'react';
import Select from 'react-select';

function getSelectedValue(options) {
  if (!options) return null;
  return Array.isArray(options) ? options.map(({ value }) => value) : options.value;
}

const FilterDropdown = ({ options_list, onChange, filter, multiple }) => {
  var value = filter ? filter.value : '';
  var selectedValue = options_list.filter(option => {
    return value && Array.isArray(value)
      ? value.includes(option.value)
      : option.value === value;
  });
  if (selectedValue && !multiple) selectedValue = selectedValue[0];
  return (
    <Select
      value={selectedValue}
      onChange={selected => onChange(getSelectedValue(selected))}
      isMulti={multiple}
      options={options_list}
      styles={{ menuPortal: base => ({ ...base, zIndex: 1 }) }}
      menuPortalTarget={document.body}
    />
  );
};

export default FilterDropdown;
